import cloneDeep from 'lodash/cloneDeep'
import { timezoneDate } from 'utils/helpers'

export const groupProposalsByClient = (companies = [], proposals = [], property) => {
  const cloneProposals = cloneDeep(proposals)

  const proposalsObj = cloneProposals.reduce((r, a) => {
    r[a.company[property]] = r[a.company[property]] || []
    r[a.company[property]].push(a)
    return r
  }, Object.create(null))

  if (companies.length !== Object.keys(proposalsObj).length) {
    companies.forEach(company => {
      if (!Object.keys(proposalsObj).includes(company.label)) {
        proposalsObj[company.label] = String(company.value)
      }
    })
  }

  return proposalsObj
}

export const teamByClient = (team = '', property) => {
  if (!team) return []
  const cloneTeam = cloneDeep(JSON.parse(team)).team

  return cloneTeam.reduce((r, a) => {
    r[a[property]] = r[a[property]] || []
    r[a[property]].push(a)
    return r
  }, Object.create(null))
}

const formatDate = date => timezoneDate(date)

export const checkDealProposalsFollowUpDates = (followUpDate, proposals) => {
  if (!proposals?.length) {
    return false
  }
  const dates = proposals.map(proposal => proposal.followUpDate)
  const hasDifferentDates = dates.filter(date => formatDate(date) !== formatDate(followUpDate))
  return !!hasDifferentDates.length
}

export const getPercentageValue = value => (value ? `${value}%` : 'N/A')
